import { defineMessages } from 'react-intl-next';

export default defineMessages({
    zeroStarRating: {
        defaultMessage: 'No rating',
        description: 'Label to support screen readers for no rating selected',
        id: 'cv.feedback.confirm.page.zero.star.rating.label',
    },
    oneStarRating: {
        defaultMessage: 'One star rating',
        description: 'Label to support screen readers for one star rating icon',
        id: 'cv.feedback.confirm.page.one.star.rating.label',
    },
    twoStarRating: {
        defaultMessage: 'Two star rating',
        description: 'Label to support screen readers for two star rating icon',
        id: 'cv.feedback.confirm.page.two.star.rating.label',
    },
    threeStarRating: {
        defaultMessage: 'Three star rating',
        description: 'Label to support screen readers for three star rating icon',
        id: 'cv.feedback.confirm.page.three.star.rating.label',
    },
    fourStarRating: {
        defaultMessage: 'Four star rating',
        description: 'Label to support screen readers for four star rating icon',
        id: 'cv.feedback.confirm.page.four.star.rating.label',
    },
    fiveStarRating: {
        defaultMessage: 'Five star rating',
        description: 'Label to support screen readers for five star rating icon',
        id: 'cv.feedback.confirm.page.five.star.rating.label',
    },
});
